/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BottomBannerDto } from '../../models/bottom-banner-dto';

export interface BottomBannerClientControllerFindAllV1$Params {
}

export function bottomBannerClientControllerFindAllV1(http: HttpClient, rootUrl: string, params?: BottomBannerClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BottomBannerDto>>> {
  const rb = new RequestBuilder(rootUrl, bottomBannerClientControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BottomBannerDto>>;
    })
  );
}

bottomBannerClientControllerFindAllV1.PATH = '/api/v1/bottom-banners/client';
